import { FieldValidationState } from '@cld/common-definitions';
import { createTheme, createVariant, globalTheme } from '@cld/component-theme';
import { TypographySize, TypographyType } from '@cld/typography';
import { LabelRatio } from './LayoutProps';

export const typographyConfig = (size: TypographySize, type: TypographyType) => ({ size, type });

export const theme = createTheme({
  validation: {
    none: { icon: 'none' },
    success: { icon: 'checkCircle' },
    warning: { icon: 'error' },
    error: { icon: 'warning' },
    typography: {
      none: typographyConfig('xxs', 'lowContrast'),
      success: typographyConfig('xxs', 'success'),
      warning: typographyConfig('xxs', 'warning'),
      error: typographyConfig('xxs', 'error'),
    },
    margin: {
      vertical: globalTheme.spacing.xs,
    },
  },
  label: {
    typography: typographyConfig('xs', 'lowContrast'),
    mandatoryTypography: typographyConfig('xs', 'error'),
    margin: {
      vertical: globalTheme.spacing.xs,
    },
    ratio: {
      xs: 0.3335,
      sm: 0.4,
      md: 0.5,
    },
  },
  layout: {
    gap: globalTheme.spacing.xs,
    margin: {
      bottom: globalTheme.spacing.xs,
    },
  },
});

//  fixme theme definition has issues when storing typography mixins  as variables but this is good case
export const validationVariant = createVariant((props: { type: FieldValidationState }) => theme.validation.typography[props.type]);

export const getLabelRatio = (labelRatio: LabelRatio = 'sm', config: ReturnType<typeof theme.label.ratio>) =>
  typeof labelRatio === 'number' ? labelRatio : config[labelRatio];
